import React from "react";

// Alae Dental wordmark logo. Inverted (linen) variant used on dark backgrounds.
const LOGO_URL = "/assets/alae-logo.png";

export default function Logo({ className = "", size = "md", invert = false }) {
  const heights = {
    sm: "h-8",
    md: "h-12 md:h-14",
    lg: "h-16",
  };
  return (
    <img
      src={LOGO_URL}
      alt="Alae Dental"
      width="200"
      height="200"
      loading="eager"
      decoding="sync"
      className={`${heights[size] || heights.md} w-auto object-contain ${
        invert ? "brightness-0 invert" : ""
      } ${className}`}
    />
  );
}
